export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6403.a9f0442f.jpg";